import Api from '../http.service';
// fetch employee role
export const getAll = () => Api.GET({ url: 'role' });
